import React from 'react'
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs'
import { cn } from '@/lib/utils'

export interface TabItem {
  value: string
  label: string
  content: React.ReactNode
}

interface TabsWithActionsProps {
  activeTab: string
  onTabChange: (value: string) => void
  tabs: TabItem[]
  rightAction?: React.ReactNode
  className?: string
}

export const TabbedSection = ({
  activeTab,
  onTabChange,
  tabs,
  rightAction,
  className,
}: TabsWithActionsProps) => {
  return (
    <Tabs
      value={activeTab}
      onValueChange={onTabChange}
      className="w-full gap-0"
    >
      <div className="flex items-center justify-between flex-wrap gap-2 h-15">
        <TabsList
          className={cn(
            'flex items-center h-auto gap-1.5 p-1 bg-transparent w-fit flex-wrap',
            className
          )}
        >
          {tabs.map(tab => (
            <TabsTrigger
              key={tab.value}
              value={tab.value}
              className="
                bg-transparent text-ss-neutral-950 px-4 py-1.5 lg:px-6 lg:py-3 
                rounded-[36px] text-sm font-semibold transition-colors 
                hover:bg-ss-neutral-25 
                data-[state=active]:bg-ss-blue-900 
                data-[state=active]:text-white h-auto
              "
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>

        {rightAction && <div>{rightAction}</div>}
      </div>

      {tabs.map(tab => (
        <TabsContent
          key={tab.value}
          value={tab.value}
          id={`${tab.value}-content`}
        >
          {tab.content}
        </TabsContent>
      ))}
    </Tabs>
  )
}
